import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

/**
 * Reusable inline date-grid. Wraps PrimeNG's inline datepicker (p-datepicker) and restyles it to
 * the app's look (Japanese "yyyy年 M月" title, 日〜土 weekday header with Sunday red / Saturday blue,
 * theme-aware light + dark). The month/weekday names come from the global PrimeNG translation set in
 * AppModule.
 *
 * Dumb + controlled: bind the selection with [(value)] and bound the range with [minDate]/[maxDate];
 * days outside the range are disabled by PrimeNG. Callers own any surrounding buttons (本日 / 設定 …).
 */
@Component({
  selector: 'caremoni-custom-calendar',
  templateUrl: './custom-calendar.component.html',
  styleUrls: ['./custom-calendar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomCalendarComponent {
  /** Selected date (two-way via [(value)]). */
  @Input() value!: Date;
  @Output() valueChange = new EventEmitter<Date>();

  /** Selectable range. Days before minDate / after maxDate are disabled. */
  @Input() minDate?: Date;
  @Input() maxDate?: Date;

  onModelChange(next: Date): void {
    this.value = next;
    this.valueChange.emit(next);
  }
}
